export const popularSizes = {
  shoes: {
    men: { eu: ['40', '41', '42', '43', '44'], us: ['8', '9', '10', '11'] },
    women: { eu: ['37', '38', '39', '40', '41'], us: ['7', '8', '9', '10'] },
  },
  'mens-clothing': {
    men: { international: ['S', 'M', 'L', 'XL'], eu: ['48', '50', '52'] },
  },
  'womens-clothing': {
    women: { international: ['S', 'M', 'L', 'XL'], eu: ['36', '38', '40'] },
  },
  jeans: {
    men: { waistIn: ['30', '32', '34', '36'], international: ['M', 'L', 'XL'] },
    women: { waistIn: ['26', '28', '30', '32'], international: ['S', 'M', 'L'] },
  },
  'kids-shoes': {
    kids: { eu: ['28', '30', '32', '34', '36'], cm: ['18', '19', '20', '21', '23'] },
  },
};

export function getPopularSizes(categoryId, gender, systemId) {
  const cat = popularSizes[categoryId];
  if (!cat) return [];
  const genderData = cat[gender] || cat.men || cat.women;
  if (!genderData) return [];
  return genderData[systemId] || Object.values(genderData)[0] || [];
}
